<template>
    <div class="container">
      <div class="header">
        <span style="color: #333333;font-size: 16px;font-weight: 400;cursor: pointer" @click="$router.go(-1)"><i class="el-icon-arrow-left"></i>返回首页</span>
        <span style="color: #333333;font-weight: 400;font-size: 20px">手机号设置</span>
        <span></span>
      </div>
      <div class="content">
        <el-form :model="form" :rules="rules" ref="form">
          <el-form-item prop="userMobile">
            <el-input v-model="form.userMobile" prefix-icon="el-icon-message" placeholder="请输入您的手机号"
                      autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button style="width: 100%;background: #DC2325;color: #fff" @click="found('form')">提交</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </template>
  
  <script>
  import api from "@/api";
  import cookie from "@/api/cookie";
  
  export default {
    name: "index",
    data() {
      return {
        form: {
          userId: cookie.getCookie('userId'),
          userMobile: ""
        },
        rules: {
          userMobile: [
            {required: true, message: '请输入手机号', trigger: 'blur'},
          ]
        }
      }
    },
    mounted() {
  
    },
    methods: {
      found(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            let that = this
            this.$confirm('确定要把手机号修改成'+this.form.userMobile,{
              closeOnClickModal:false
            })
            .then(_ => {
             console.log('我点击确认了')  
              api.editMobile(this.form).then(res => {
                that.$message.success("手机号修改成功！,请重新登录")
                that.form = {}
                cookie.removeCookie("userId");
                cookie.removeCookie("token");
                that.$store.commit("setUser");
                that.$router.push("/");
              })
            })


            // // eslint-disable-next-line no-unused-vars
          
          } else {
            return false;
          }
        });
      }
    }
  }
  </script>
  
  <style lang="scss" scoped>
  .container {
    width: 1200px;
    margin: 20px auto;
    height: 663px;
    background: #ffffff;
  
    .header {
      display: flex;
      justify-content: space-between;
      padding: 20px 10px;
      border-bottom: 1px solid #F0F0F0;
    }
  
    .content {
      width: 370px;
      margin: 50px auto;
    }
  }
  </style>
  